import React, { useState } from 'react';
import { Link as RouterLink, withRouter, useHistory, useLocation } from 'react-router-dom';
import { Card, CardContent, CardActionArea, Avatar, Typography, Drawer, List, Divider, ListItem, ListItemIcon, ListItemText, Grid } from '@material-ui/core';
import { ExitToAppOutlined, SettingsOutlined, Menu } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { styles } from './styles';
import { useTranslation } from 'react-i18next';
import Notifications from '../../Notifications';
import { connect } from 'react-redux';
import WorkspaceMenu from '../WorkspaceMenu';
import ChangeLanguage from '../ChangeLanguage';

const AppNavMobile = (props) => {
  const classes = styles();
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const { t } = useTranslation();
  const { handleLogout, visibleTabs, user, group, subgroup, groups, returnIcon, setLoading, logo } = props;

  const role = user.signInUserSession.idToken.payload.role;
  const urlAdminFront = process.env.REACT_APP_ADMIN_FRONT_URL;
  const showLinkAdmin = urlAdminFront && role === 'admin';

  const history = useHistory();

  const showWorkspaces = groups.length > 1 || groups[0].subgroups > 1;

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    setOpen(open);
  };

  const list = () => (
    <div
      role='presentation'
    >
      <Card className={classes.card_user}>
        <CardActionArea >
          <CardContent className={classes.card_content}>
            <Grid container
              direction='row'
              justify='space-between'
              alignItems='center'
            >
              <Avatar onClick={() => history.push('/profile')}>
                { user.username.substring(0, 1).toUpperCase()}
              </Avatar>
              {showWorkspaces && <WorkspaceMenu setLoading={setLoading} /> }
            </Grid>

            <Typography variant='body2' component='h2'>
              { showWorkspaces && <div>{ group } - { subgroup }:</div>} { user.username}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
      <Divider style={{ backgroundColor: '#FFFFFF' }} />
      <List>
        { visibleTabs.map((current) => (
          <ListItem
            button
            classes={{ selected: classes.list_item }}
            key={t(`appNavMobile:${current.label}`)}
            component={RouterLink}
            to={current.url}
            selected={location.pathname === current.url}
            onClick={toggleDrawer(false)}
          >
            <ListItemIcon className={classes.list_icon}>
              { returnIcon(current.icon) }
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography variant='subtitle2'>{ t(`appNavMobile:${current.label}`) }</Typography>
              }
              className={classes.list_text}
            />
          </ListItem>
        )) }
      </List>
      <Divider style={{ marginBottom: '25px', backgroundColor: '#FFFFFF' }} />
      <List>
        { showLinkAdmin &&
        <ListItem button key='Administracion'>
          <ListItemIcon className={classes.list_icon}>
            <SettingsOutlined />
          </ListItemIcon>
          <a href={`${urlAdminFront}`} target='_blank' className={classes.noDecoration}>
            <ListItemText
              primary={
                <Typography variant='subtitle2'>{ t('userMenu:admin') }</Typography>
              }
              className={classes.list_text}
            />
          </a>
        </ListItem>}
        <ListItem button key='Salir' onClick={() => handleLogout()}>
          <ListItemIcon className={classes.list_icon}>
            <ExitToAppOutlined />
          </ListItemIcon>
          <ListItemText
            primary={<Typography variant='subtitle2'>{ t('appNavMobile:exit') }</Typography>}
            className={classes.list_text}
          />
        </ListItem>
      </List>
    </div>
  );

  return (
    <div className={classes.container_nav_icon}>
      <Menu color='primary' onClick={() => setOpen(true)} />
      <img className={classes.logo} src={logo} alt='Logo' />
      <div className={classes.container_user}>
        <Notifications />
        <ChangeLanguage />
      </div>
      <React.Fragment key='left'>
        <Drawer
          anchor='left'
          open={open}
          onClose={toggleDrawer(false)}
          className={classes.drawer}
        >
          { list() }
        </Drawer>
      </React.Fragment>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    filter: state.filter,
    visibleTabs: state.config.visibleTabs,
    customTheme: state.config.theme,
    config: state.config,
    subgroup: state.config.subgroup,
    groups: state.config.groups,
    group: state.config.group,
    user: state.config.user
  };
};

AppNavMobile.propTypes = {
  customTheme: PropTypes.object,
  visibleTabs: PropTypes.array.isRequired,
  config: PropTypes.object.isRequired,
  subgroup: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  groups: PropTypes.array.isRequired,
  group: PropTypes.string.isRequired,
  setLoading: PropTypes.func.isRequired,
  returnIcon: PropTypes.func.isRequired,
  handleLogout: PropTypes.func.isRequired
};

export default connect(mapStateToProps, null)(withRouter(AppNavMobile));
